import { createRoot } from 'react-dom/client';
import { isMac } from './platform';
import { migrateLegacyRecorderPreferences } from './lib/recorderPreferenceStorage';

document.body.classList.add(isMac ? 'mac' : 'win');

async function bootstrapRenderer() {
  migrateLegacyRecorderPreferences(window.localStorage);

  const { default: App } = await import('./App');
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const container = document.getElementById('app')!;
  const root = createRoot(container);
  root.render(<App />);
}

bootstrapRenderer();
